import React from "react";
import { MagnifyingGlass, Crosshair, Plus } from "@phosphor-icons/react";

export function LocationSearchForm({
  query,
  setQuery,
  searching,
  onSubmit,
  onUseMyLocation,
  inputRef,
}) {
  return (
    <>
      <form onSubmit={onSubmit} className="flex gap-2">
        <div className="relative flex-1">
          <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-tac-faint" />
          <input
            ref={inputRef}
            data-testid="geocode-search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Address + town (e.g. 911 Aeneas Valley Rd, Tonasket)"
            className="w-full bg-tac-surface border border-tac-border focus:border-tac-primary rounded-sm pl-8 pr-3 py-2 text-[15px] text-tac-text placeholder:text-tac-faint outline-none"
          />
        </div>
        <button
          data-testid="geocode-search-submit"
          type="submit"
          disabled={searching || !query.trim()}
          className="px-3 py-2 text-[10px] font-bold uppercase tracking-wider bg-tac-primary text-white rounded-sm hover:bg-tac-primary/90 disabled:opacity-40"
        >
          {searching ? "..." : "Search"}
        </button>
      </form>

      <button
        data-testid="use-my-location"
        onClick={onUseMyLocation}
        disabled={searching}
        className="w-full flex items-center justify-center gap-2 px-3 py-2 text-[10px] font-bold uppercase tracking-wider border border-tac-border bg-tac-surface hover:bg-tac-surface2 hover:border-tac-borderBright text-tac-text rounded-sm transition-colors"
      >
        <Crosshair size={12} weight="bold" /> Use my current location
      </button>
    </>
  );
}

export function GeocodeResults({ results, onSelect }) {
  if (results.length === 0) return null;
  return (
    <div
      className="border border-tac-border bg-tac-surface/60 rounded-sm divide-y divide-tac-border/60 max-h-48 overflow-y-auto tac-scroll"
      data-testid="geocode-results"
    >
      {results.map((r, idx) => (
        <button
          key={`${r.lat}-${r.lon}-${r.display_name}`}
          data-testid={`geocode-result-${idx}`}
          onClick={() => onSelect(r)}
          className="w-full text-left px-3 py-2 hover:bg-tac-surface2 flex items-start gap-2"
        >
          <Plus size={12} weight="bold" className="text-tac-primary shrink-0 mt-1" />
          <div className="min-w-0">
            <div className="text-xs text-tac-text truncate">{r.display_name}</div>
            <div className="text-[15px] font-mono-tac tabular text-tac-faint">
              {r.lat.toFixed(4)}, {r.lon.toFixed(4)}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
